// Gemeinsame Buehne aller Launcher-Varianten.
// Die SVG-Buehne ist SW x SH gross und sitzt unten rechts, die Button-Mitte liegt bei (BX, BY).

export const SW = 280
export const SH = 320
export const BX = SW - 32
export const BY = SH - 32
export const BR = 32

export const BORDER = '#E3E6EC'

// Robert Penners easeOutBounce
export const bounceOut = (x) => {
  const n = 7.5625
  const d = 2.75
  if (x < 1 / d) return n * x * x
  if (x < 2 / d) return n * (x -= 1.5 / d) * x + 0.75
  if (x < 2.5 / d) return n * (x -= 2.25 / d) * x + 0.9375
  return n * (x -= 2.625 / d) * x + 0.984375
}

// Blickrichtung zur Maus, Laenge 0..1
export const lookDir = (ui) => {
  const d = Math.hypot(ui.px, ui.py) || 1
  return [ui.px / d, ui.py / d]
}

// Periodisches Blinzeln, liefert 1 (offen) bis ~0.12 (zu)
export const blink = (t, period = 4.2, offset = 0) => {
  const ph = (t + offset) % period
  return ph > period - 0.16 ? 0.12 : 1
}
